<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">乘客:</span>
                    <!-- 按用户code搜索 -->

                    <el-select
                        v-model="value_consumer_code"
                        placeholder="请选择乘客"
                        style="width: 200px; margin-right: 20px"
                        @visible-change="consumerVisibleChange"
                        @change="consumerChange"
                        clearable
                    >
                        <el-option v-for="item in options_consumer_code" :key="item.value" :label="item.name" :value="item.consumer_code">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="12">
                    <el-button
                        style="margin-left: 30px"
                        :class="more_search ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                        @click="more_search = !more_search"
                    >
                        详细搜索
                    </el-button>
                </el-col>
            </el-row>
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">银行卡:</span>
                    <!-- 搜索银行卡 -->
                    <el-input
                        v-model="search_data.bank_card_no"
                        placeholder="请输入银行卡号"
                        class="handle-input mr10"
                        maxlength="19"
                        @keyup.enter.native="searchConsumerBankCardLists"
                    >
                    </el-input>
                </el-col>
            </el-row>

            <div v-show="more_search" style="margin-top: 10px">
                <el-row class="head-search">
                    <el-col :span="24" style="margin: 10px 0">
                        <span class="title">审核状态:</span>
                        <el-radio-group v-model="search_data.status" size="small">
                            <el-radio label="" border> 全部</el-radio>
                            <el-radio v-for="(item, index) in value_status_array" :key="index" :label="String(item.val)" border>
                                {{ item.alias }}</el-radio
                            >
                        </el-radio-group>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchConsumerBankCardLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div class="more-style">
                            <el-form-item label="唯一编码:">
                                <span>{{ props.row.consumer_bank_card_code }}</span>
                            </el-form-item>
                            <el-form-item label="开户行:">
                                <span>{{ props.row.address }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="创建时间:">
                                <span>{{ props.row.time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="创建详细时间:">
                                <span>{{ props.row.time.YmdHis }}</span>
                            </el-form-item>
                        </div>

                        <el-form-item label="审核备注:" v-if="props.row.reason != null">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column prop="id" label="id" width="80"> </el-table-column>

            <el-table-column label="银行编码">
                <template scope="scope">
                    <el-image
                        :src="'https://apimg.alipay.com/combo.png?d=cashier&t=' + scope.row.bank_card_code"
                        v-if="scope.row.bank_card_code != ''"
                    ></el-image>
                </template>
            </el-table-column>

            <el-table-column prop="bank_card_no" label="卡号" width="300"> </el-table-column>

            <el-table-column prop="bank_card_name" label="持卡人"> </el-table-column>

            <el-table-column label="审核状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}</el-tag
                    >
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="
                            edit_consumer_bank_card_isShow = !edit_consumer_bank_card_isShow;
                            edit_consumer_bank_card_data = scope.row.consumer_bank_card_code;
                        "
                        trigger="click"
                    >
                        编辑

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="untying(scope.row.consumer_bank_card_code)">解绑</el-dropdown-item>

                            <el-dropdown-item @click.native="examine(scope.row)"> 审核 </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 修改组件 -->
        <editConsumerBankCard
            :isShow="edit_consumer_bank_card_isShow"
            @onSubmit="consumerBankCardLists"
            :data="edit_consumer_bank_card_data"
        ></editConsumerBankCard>

        <!-- 审核组件 -->
        <userToExamineBankCard
            :isShow="toExamine_isShow"
            @onSubmit="consumerBankCardLists"
            :data="edit_consumer_bank_card_data"
            :examine_status="examine_status"
            :remarks="remarks_BankCard"
        >
        </userToExamineBankCard>
    </div>
</template>

<script>
var _this;
import editConsumerBankCard from './editConsumerBankCard.vue';
import userToExamineBankCard from './userToExamineBankCard.vue';
export default {
    components: {
        editConsumerBankCard,
        userToExamineBankCard
    },
    data() {
        return {
            // 传入子组件的数据
            consumer_code_children: '',

            //详细搜索
            more_search: false,

            // 修改组件开关
            edit_consumer_bank_card_isShow: false,

            // 修改组件传值
            edit_consumer_bank_card_data: '',

            // 银行卡审核组件开关
            toExamine_isShow: false,
            examine_status: '',
            remarks_BankCard: '',

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: [],

            // 按用户code搜索
            value_consumer_code: '',
            options_consumer_code: [],
            consumer_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                consumer_code: '',
                status: '',
                bank_card_no: '',
                consumer_name: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.consumerBankCardLists();
    },

    methods: {
        examine(scope) {
            _this.toExamine_isShow = !_this.toExamine_isShow;
            _this.edit_consumer_bank_card_data = scope.consumer_bank_card_code;
            _this.examine_status = scope.status.val;
            if (scope.remarks != null) {
                _this.remarks_BankCard = scope.remarks;
            } else {
                _this.remarks_BankCard == '';
            }
        },
        searchConsumerBankCardLists() {
            _this.search_data.page = 1;
            _this.consumerBankCardLists();
        },
        // 搜索司机银行卡列表
        consumerBankCardLists() {
            _this
                .$post('/consumer/consumerBankCardLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    _this.value_status_array = res.data[0].status.select_array;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.consumerBankCardLists();
        },
        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].consumer_code);
            }
            _this.delConsumerSubmit_data.consumer_code_array = datalist;
        },

        consumerChange(val) {
            _this.search_data.consumer_code = val;
        },
        //搜索的下拉框弹出触发
        consumerVisibleChange(val) {
            if (val && _this.options_consumer_code.length < 1) {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/consumer/consumerLists', _this.consumer_options_data)
                    .then((res) => {
                        _this.options_consumer_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },
        untying(code) {
            console.log(code);

            _this
                .$confirm('此操作将解绑该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/consumer/delConsumerBankCardSubmit', {
                            consumer_bank_card_code: code
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);
                            _this.consumerBankCardLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>